import { memo } from 'react';
import { Box, Icon, Text } from '@betty/moonlight';

function PendingVerificationCard() {
  return (
    <Box
      borderWidth="border-width-025"
      variant="outline-gradient"
      borderRadius="radius-200"
      gradient="borderAccent"
      padding="space-400"
      gap="space-200"
    >
      <Box flexDirection="row" gap="space-100" alignItems="center">
        <Icon
          name="info"
          width="space-600"
          height="space-600"
          color="darkSurfacePrimary"
        />
        <Text
          variant="body-s-semi"
          color="darkSurfaceTertiary"
          locKey="pendingVerificationCardTitle"
          locNS="account"
        />
      </Box>
      <Text
        variant="caption"
        color="darkSurfaceMuted"
        locKey="pendingVerificationCardDescription"
        locNS="account"
      />
    </Box>
  );
}

export default memo(PendingVerificationCard);
